import { render, staticRenderFns } from "./organizationDetails.vue?vue&type=template&id=14128c1a&"
import script from "./organizationDetails.vue?vue&type=script&lang=js&"
export * from "./organizationDetails.vue?vue&type=script&lang=js&"
import style0 from "./organizationDetails.vue?vue&type=style&index=0&id=14128c1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports